// extracted by mini-css-extract-plugin
export default {"navtitle":"AppHdSingleTitle_navtitle__zapI+"};